import { get } from '@/helpers';

export const getShippingFee = shippingMethod => {
    let fee = 0;
    switch (shippingMethod.price_type) {
        case 'flat-rate':
            fee = get(shippingMethod, 'mainPrice.value', 0);
            break;

        case 'country':
            // TODO
            break;

        // TODO
        // process other price types
    }
    return fee;
};

export const getPropertyValues = pivot => {
    const property = pivot?.property;
    const valueField = pivot?.property?.propType?.value_field;
    const valueFieldAlt = pivot?.property?.propType?.value_field_alt;

    const values = pivot?.values || [];
    // return values.map(el => ({ label: property.name, value: el[valueField] || el[valueFieldAlt] }))

    return { label: property?.name, values: values.map(el => el[valueField] || el[valueFieldAlt]) };
};
